module.exports = __webpack_public_path__ + "static/media/emacs.8a19b9c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/emacs.png
// module id = 93
// module chunks = 0